import React from 'react';
import { withTheme } from 'styled-components';
export var MaterialesIndustrialesIcon = function MaterialesIndustrialesIcon(_ref) {
  var theme = _ref.theme;
  return React.createElement("svg", {
    width: "292px",
    height: "259px",
    viewBox: "0 0 292 259",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Materiales industriales"), React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("g", {
    id: "Materiales-industriales",
    transform: "translate(-41.000000, -5.000000)",
    stroke: theme.colors.primary,
    strokeWidth: "15"
  }, React.createElement("g", {
    id: "materiales_industriales",
    transform: "translate(48.000000, 12.000000)"
  }, React.createElement("g", {
    id: "Tools-Construction__x2F__Tools__x2F__tools-box-1"
  }, React.createElement("g", {
    id: "Group_3"
  }, React.createElement("g", {
    id: "Light_2"
  }, React.createElement("path", {
    d: "M208.28,187.64 C207.62,184.74 208.28,181.69 210.09,179.33 C211.9,176.97 214.67,175.53 217.64,175.41 L233.61,174.78 C236,174.68 238.34,175.44 240.22,176.92 L260.65,193.07 C263.62,195.42 267.68,195.89 271.11,194.28 C274.55,192.67 276.78,189.26 276.87,185.47 C277.47,163.41 265.86,142.83 246.67,131.93 C227.48,121.04 203.85,121.61 185.22,133.43 L116.57,79.15 C124.82,55.14 117.04,28.54 97.14,12.77 C82.46,1.97 63.75,-1.79 46.04,2.5 C42.25,3.32 39.27,6.25 38.39,10.03 C37.51,13.81 38.9,17.75 41.94,20.15 L61.55,35.66 C63.42,37.15 64.7,39.25 65.15,41.6 L68.22,57.28 C68.79,60.2 68.03,63.23 66.15,65.53 C64.27,67.84 61.45,69.18 58.48,69.21 L43.08,69.31 C40.8,69.33 38.58,68.56 36.8,67.15 L17.1,51.57 C14.06,49.16 9.9,48.73 6.43,50.45 C2.96,52.17 0.79,55.75 0.867861299,59.62 C0.74,77.86 8.7,95.22 22.6,107.04 C42.55,122.76 70.24,124.19 91.7,110.6 L160.34,164.87 C153.12,185.73 158,208.86 173.03,225.02 C188.06,241.18 210.78,247.73 232.11,242.04 C235.78,241.07 238.58,238.11 239.36,234.4 C240.13,230.69 238.74,226.85 235.77,224.5 L215.22,208.25 C213.43,206.83 212.18,204.85 211.67,202.63 L208.28,187.64 Z",
    id: "Shape_10"
  }))))))));
};
export default withTheme(MaterialesIndustrialesIcon);